"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const react_use_1 = require("react-use");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const List_1 = __importDefault(require("@mui/material/List"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const CategoryField_1 = __importDefault(require("components/QuickenControls/CategoryField"));
const Dump_1 = __importDefault(require("components/Dump"));
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const utils_1 = require("utils/utils");
const icon_arrow_right_svg_1 = __importDefault(require("assets/icon-arrow-right.svg"));
const icons_arrow_down_svg_1 = __importDefault(require("assets/icons-arrow-down.svg"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.ResourceRowStyles);
const ResourceRow = ({ item: initialItem, isChild = false, dataDictionary, rowIndex, narrowMode = false, isExpanded, isParent, onCollapse, onSave, onDelete, onSelect, selectedItems, onRemoveNewItem, getCategoryByID, setDialog, editingProps, disabled = false, }) => {
    const { classes, theme } = useStyles();
    const [item, setItem] = (0, react_1.useState)(Object.assign({}, initialItem));
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const [editingProp, setEditingProp] = (0, react_1.useState)(null);
    const [selectOpen, setSelectOpen] = (0, react_1.useState)(false);
    const hasChanges = () => JSON.stringify(initialItem) !== JSON.stringify(item);
    const { isNewCategory = false } = item;
    const showEditing = isEditing || hasChanges() || isNewCategory;
    const itemClasses = (0, classnames_1.default)(classes.itemContainer, { [classes.itemContainerIsEditing]: showEditing });
    const indexGenerated = rowIndex.length < 2 ? [...rowIndex, 0] : rowIndex;
    const baseId = `category-${indexGenerated.join('-')}`;
    const requestEditing = () => {
        editingProps.requestEditing(item.id);
    };
    const cleanEditingData = (flagSendId = false) => {
        editingProps.cleanEditingData(flagSendId ? item.id : null);
    };
    const changeEditingProp = (editingData) => {
        const isEditingGenerated = Boolean(editingData);
        if (!isEditingGenerated && !hasChanges()) {
            cleanEditingData();
        }
        setIsEditing(isEditingGenerated);
        setEditingProp(editingData);
    };
    const onEditMode = (editingData) => {
        requestEditing();
        changeEditingProp(editingData);
    };
    const triggerInitialEditing = () => {
        if (isNewCategory && !hasChanges() && editingProp === null) {
            onEditMode('name');
        }
    };
    (0, react_use_1.useEffectOnce)(() => triggerInitialEditing());
    (0, react_1.useEffect)(() => {
        if (initialItem) {
            setItem(Object.assign({}, initialItem));
        }
    }, [initialItem]);
    const onCollapseFunc = (e) => {
        e.stopPropagation();
        onCollapse(e);
    };
    const renderCollapseIcon = () => isParent ? (<ButtonBase_1.default id={`${baseId}-collapse-button`} className={(0, classnames_1.default)(classes.collapseIcon, narrowMode ? 'narrowMode' : '')} onClick={onCollapseFunc}>
        <img alt={isExpanded ? 'Expand List' : 'Collapse List'} src={isExpanded ? icons_arrow_down_svg_1.default : icon_arrow_right_svg_1.default}/>
      </ButtonBase_1.default>) : <div className={(0, classnames_1.default)(classes.collapseIcon, narrowMode ? 'narrowMode' : '')}/>;
    const renderTextLabel = ({ index, primary, row }) => {
        const listClasses = index === 0 ? { primary } : {};
        let canGotoEditMode = true;
        let listClassname = (0, classnames_1.default)(classes.listItemText, row.editable ? classes.labelHover : '');
        let text = item[row.id] ? item[row.id] : row.defaultValue || row.placeholder;
        if (row.type === 'select') {
            text = (row.choices.find((x) => x.value === item[row.id]) || {}).title;
            canGotoEditMode = !isChild;
            listClassname = (0, classnames_1.default)(listClassname, { [classes.noCursorPointer]: !canGotoEditMode });
        }
        return (<ListItemText_1.default id={`${baseId}-${row.id}-text`} key={row.id} primary={text} style={{ flex: row.flex }} className={listClassname} classes={listClasses} onClick={row.editable ? (() => canGotoEditMode && onEditMode(row.id)) : undefined}/>);
    };
    const onDeleteFunc = () => {
        onDelete(item);
    };
    const resetChanges = () => {
        setItem(Object.assign({}, initialItem));
        setIsEditing(false);
        setEditingProp(null);
        setSelectOpen(false);
        if (isNewCategory) {
            onRemoveNewItem();
        }
        cleanEditingData();
    };
    const onCancel = (flagShowName = false) => {
        const { name } = item;
        if (hasChanges()) {
            setDialog('Discard Changes', <>Are you sure you want to cancel changes to {flagShowName ? <strong>{name}</strong> : 'this'} category?</>, (dialog) => {
                if (['YES', 'Enter'].includes(dialog.action)) {
                    resetChanges();
                }
                if (['CANCEL'].includes(dialog.action)) {
                    cleanEditingData(true);
                }
            }, ['CANCEL', 'YES']);
            return;
        }
        resetChanges();
    };
    const onSaveFunc = () => {
        if (hasChanges()) {
            onSave(item);
            cleanEditingData();
        }
        else {
            onCancel();
        }
    };
    const renderActionIcons = ({ row }) => {
        if (row.type === 'actionsSelect') {
            // Use item.name for Payees and item.id for Categories, Tags, or Accounts based on `count`
            const selected = item.count
                ? selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.includes(item.name)
                : selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.includes(item.id);
            return (<div key={row.id} className={classes.actionsSelectContainer} style={{ flex: row.flex }}>
          {narrowMode ?
                    <QCheckbox_1.default size={theme.mixins.register.checkboxSize} color="primary" disabled={disabled} onClick={onSelect && !disabled ? () => onSelect(item) : undefined} checked={selected} id={`${baseId}-select-box`} className={classes.actionIcon} aria-label="Select"/>
                    :
                        <Checkbox_1.default disabled={disabled} onClick={onSelect && !disabled ? () => onSelect(item) : undefined} checked={selected} id={`${baseId}-select-box`} className={classes.actionIcon} aria-label="Select" classes={{ root: classes.checkboxScale }}/>}
        </div>);
        }
        return (<div key={row.id} className={classes.actionsIconsContainer} style={{ flex: row.flex }}>
        {!isNewCategory &&
                <IconButton_1.default id={`${baseId}-delete-button`} className={(0, classnames_1.default)(classes.hoverIcon, classes.actionIcon)} aria-label="Delete" onClick={onDeleteFunc} size="large">
            <Delete_1.default className={classes.deleteIcon}/>
          </IconButton_1.default>}
        {showEditing && (<div className={classes.editButtonsContainer}>
            <IconButton_1.default id={`${baseId}-cancel-button`} className={classes.actionIcon} aria-label="Cancel" onClick={() => onCancel()} size="large">
              <Cancel_1.default className={classes.cancelIcon}/>
            </IconButton_1.default>
            <IconButton_1.default id={`${baseId}-save-button`} className={classes.actionIcon} aria-label="Save" onClick={onSaveFunc} size="large">
              <CheckCircle_1.default className={classes.saveIcon}/>
            </IconButton_1.default>
          </div>)}
      </div>);
    };
    const onBlur = (prop) => (e) => {
        if (prop !== 'parent' ||
            (prop === 'parent' && !(e && e.relatedTarget) && !(0, utils_1.isBrowser)('safari') && !(0, utils_1.isBrowser)('firefox'))) {
            setEditingProp(null);
            setIsEditing(false);
        }
    };
    const onChange = (editProp) => (e) => {
        const getCategory = () => {
            var _a;
            if (getCategoryByID && getCategoryByID(e.id))
                return (_a = getCategoryByID(e.id)) === null || _a === void 0 ? void 0 : _a.name;
            return '';
        };
        const newItem = editProp === 'parent' ? Object.assign(Object.assign({}, item), { parent: (e && e.id && e.id !== '0') ? (getCategory()) : '', values: Object.assign(Object.assign({}, item.values), { parent: e }) }) : Object.assign(Object.assign({}, item), { [editProp]: e.target.value });
        setItem(Object.assign({}, newItem));
    };
    const onKeyPress = (nextRow) => (event) => {
        // If select is open all keyPress events must be handled by the selectComponent
        if (selectOpen) {
            return;
        }
        if (event.key === 'Enter') {
            onSaveFunc();
        }
        else if (event.key === 'Escape') {
            onCancel();
        }
        else if (event.key === 'Tab' && nextRow && nextRow.id && nextRow.editable) {
            setTimeout(() => onEditMode(nextRow.id), 0);
        }
    };
    const onSelectToggle = () => {
        setSelectOpen(!selectOpen);
    };
    const renderSelectItems = (choices) => choices.map((option) => (<MenuItem_1.default key={option.value} value={option.value}>
      {option.title}
    </MenuItem_1.default>));
    const renderFields = ({ row, index, root, nextRow }) => {
        var _a;
        const sharedProps = {
            id: `${baseId}-${row.id}-field`,
            key: row.id,
            autoFocus: true,
            onBlur: onBlur(row.id),
            onChange: onChange(row.id),
            onKeyPress: onKeyPress(nextRow),
            onKeyDown: onKeyPress(nextRow),
            placeholder: row.placeholder,
            value: item[row.id] ? item[row.id] : '',
        };
        let fieldProps = {};
        switch (row.type) {
            case 'string': {
                const inputDefaultClasses = { input: classes.textField };
                fieldProps = {
                    InputProps: {
                        disableUnderline: true,
                        classes: index === 0 ? Object.assign({ root }, inputDefaultClasses) : inputDefaultClasses,
                    },
                };
                break;
            }
            case 'select': {
                fieldProps = {
                    select: true,
                    classes: {
                        root: classes.textField,
                    },
                    variant: 'standard',
                    SelectProps: {
                        disableUnderline: true,
                        open: selectOpen,
                        onOpen: onSelectToggle,
                        onClose: onSelectToggle,
                        classes: { select: classes.selectField },
                    },
                    children: renderSelectItems(row.choices),
                };
                break;
            }
            case 'CategoryField': {
                fieldProps = {
                    value: '',
                    InputProps: {
                        classes: { root: classes.textField },
                        disableUnderline: true,
                        'aria-label': 'Subcategory',
                        inputComponent: CategoryField_1.default,
                        inputProps: {
                            blurOnMenuClose: true,
                            disableUnderline: true,
                            editable: true,
                            allowNone: true,
                            onlyL1: false,
                            filterFn: (cat) => cat.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY || cat.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.NONE,
                            menuPosition: 'absolute',
                            'aria-label': 'Subcategory',
                            value: ((_a = item.values) === null || _a === void 0 ? void 0 : _a.parent) || '',
                        },
                    },
                };
                break;
            }
            default:
                return null;
        }
        return (<div key={sharedProps.key} style={{ flex: row.flex }} className={classes.listItemText}>
        <TextField_1.default {...sharedProps} {...fieldProps}/>
      </div>);
    };
    const renderItemContent = () => (<div className={(0, classnames_1.default)(classes.itemContentContainer, narrowMode ? 'narrowMode' : '')}>
      <Dump_1.default obj={item}/>
      {dataDictionary.map((row, index) => {
            const showIndent = isChild;
            let root;
            if (showIndent) {
                root = classes === null || classes === void 0 ? void 0 : classes[`itemIdent-L${item.level}`]; // Quicken has L2 to L16
            }
            else {
                root = classes.firstItem; // L1
            }
            const nextRow = (index + 1) < dataDictionary.size ? dataDictionary.get(index + 1) : undefined;
            if (row.type === 'actions' || row.type === 'actionsSelect') {
                return renderActionIcons({ row });
            }
            if (isEditing && editingProp === row.id && row.editable) {
                return renderFields({ row, index, root, nextRow });
            }
            return renderTextLabel({ row, index, primary: root });
        })}
    </div>);
    return (<List_1.default id={`${baseId}-row-container`} dense className={classes.listContainer}>
      <ListItem_1.default id={`${baseId}-row-item`} className={itemClasses} onClick={onSelect && !disabled ? () => onSelect(item) : undefined}>
        {renderCollapseIcon()}
        {renderItemContent()}
      </ListItem_1.default>
    </List_1.default>);
};
exports.default = ResourceRow;
